var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8311 18.7377C12.7972 19.7403 11.6685 19.582 10.5819 19.1071C9.43206 18.6216 8.37714 18.6005 7.16399 19.1071C5.64491 19.7615 4.84317 19.5715 3.93595 18.7377C-1.21205 13.4289 -0.452507 5.34439 5.39173 5.04887C6.81587 5.12275 7.80749 5.82988 8.64087 5.89321C9.88567 5.63991 11.0777 4.91167 12.4069 5.00665C13.9998 5.1333 15.2025 5.76656 15.9936 6.90641C12.7023 8.88005 13.4829 13.2178 16.5 14.4316C15.8987 16.0147 15.1181 17.5873 13.8205 18.7483L13.8311 18.7377ZM8.53538 4.98554C8.37714 2.63195 10.2865 0.689976 12.4808 0.5C12.7867 3.22299 10.0123 5.2494 8.53538 4.98554Z",
    fill: "#1D7E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.070599a1d0997ba792b61b4818968465.svg";
export { ForwardRef as ReactComponent };